import { updateModalProductInfo } from './productinfo.js';

export function initBentoBoxModal() {
    try {
        const cards = document.querySelectorAll('.cmp-bentobox-gallery-card');
        const modal = document.getElementById('bento-modal');
        const modalImg = document.getElementById('bento-modal-image');
        const modalTitle = document.getElementById('bento-modal-title');
        const modalDesc = document.getElementById('bento-modal-description');
        const closeBtnDesktop = document.getElementById('bento-modal-close');
        const closeBtnMobile = document.getElementById('bento-modal-close-mobile');
        const overlay = modal?.querySelector('.cmp-bentobox-gallery-modal__overlay');

        const closeModal = () => {
            modal.setAttribute('hidden', 'true');
            modalImg.src = '';
        };

        cards.forEach(card => {
            const button = card.querySelector('.cmp-bentobox-gallery__modal-button');
            const imageUrl = card.getAttribute('data-full-image-url');
            const metaScript = card.querySelector('.cmp-bentobox-gallery__modal-meta');

            button?.addEventListener('click', () => {
                modal.removeAttribute('hidden');
                modalImg.src = imageUrl;
                
                if (metaScript) {
                    try {
                        const meta = JSON.parse(metaScript.textContent);
                        
                        // Clear description for bentobox
                        modalTitle.innerHTML = meta.title || '';
                        modalDesc.innerHTML = '';
                        
                        // Update product info using shared utility
                        updateModalProductInfo(meta, modal);
                    } catch (e) {
                        console.error('Error parsing bentobox modal metadata:', e);
                    }
                }
            });
        });

        closeBtnDesktop?.addEventListener('click', closeModal);
        closeBtnMobile?.addEventListener('click', closeModal);
        overlay?.addEventListener('click', closeModal);
    } catch (e) {
        console.error('Error initializing bentobox modal:', e);
    }
}
